import React from "react";
import CommonCtaArea from "../../components/CommonCtaArea/CommonCtaArea";
import PageHelmet from "../../components/shared/PageHelmet";
import HomeTwoAchievement from "./HomeTwoAchievement/HomeTwoAchievement";
import HomeTwoBlogs from "./HomeTwoBlogs/HomeTwoBlogs";
import HomeTwoCaseArea from "./HomeTwoCaseArea/HomeTwoCaseArea";
import HomeTwoCounter from "./HomeTwoCounter/HomeTwoCounter";
import HomeTwoExpertArea from "./HomeTwoExpertArea/HomeTwoExpertArea";
import HomeTwoFaq from "./HomeTwoFaq/HomeTwoFaq";
import HomeTwoFeatures from "./HomeTwoFeatures/HomeTwoFeatures";
import HomeTwoChannelPartners from "./HomeTwoChannelPartners/HomeTwoChannelPartners.js";
import HomeTwoFooter from "./HomeTwoFooter/HomeTwoFooter";
import HomeTwoHeader from "./HomeTwoHeader/HomeTwoHeader";
import HomeTwoHeroSlider from "./HomeTwoHeroSlider/HomeTwoHeroSlider";
import HomeTwoTestimonial from "./HomeTwoTestimonial/HomeTwoTestimonial";
import HomeTwoJobs from "./HomeTwoJobs/HomeTwoJobs";
import HomeTwoWhyChooseUs from "./HomeTwoWhyChooseUs/HomeTwoWhyChooseUs";
import HomeTwoIndustries from "./HomeTwoIndustries/HomeTwoIndustries";
import HomeTwoPartnership from "./HomeTwoPartnership/HomeTwoPartnership";

const HomeTwo = () => {
  return (
    <>
      <PageHelmet pageTitle="Home" />

      <HomeTwoHeader />
      <HomeTwoHeroSlider />

      <HomeTwoChannelPartners />
      <HomeTwoExpertArea />
      <HomeTwoWhyChooseUs />
      <HomeTwoIndustries />
      <HomeTwoPartnership />
      <HomeTwoFeatures />
      <HomeTwoFaq />
      <HomeTwoJobs />
      <HomeTwoAchievement />
      <HomeTwoCounter />
      <HomeTwoTestimonial />
      <HomeTwoCaseArea />
      {/* <HomeTwoBlogs/> */}
      <CommonCtaArea />
      <HomeTwoFooter />
    </>
  );
};

export default HomeTwo;
